<div *ngIf="(loader.isLoading$ | async)" class="spinner-overlay">
  <div class="lds-spinner">
    <div *ngFor="let div of divsArray">
    </div>
  </div>
</div>